var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5C2.5 2.243 4.743 0 7.5 0C10.257 0 12.5 2.243 12.5 5C12.5 7.757 10.257 10 7.5 10C4.743 10 2.5 7.757 2.5 5ZM11.617 11.071C11.058 10.929 10.45 11.0091 9.94702 11.2891C8.42902 12.1331 6.57098 12.1331 5.05298 11.2891C4.55098 11.0101 3.942 10.931 3.383 11.071C1.391 11.574 0 13.382 0 15.467V16.478C0 17.116 0.169981 17.7399 0.492981 18.2839C0.755981 18.7259 1.24902 19.001 1.77802 19.001H13.221C13.75 19.001 14.243 18.727 14.506 18.283C14.829 17.74 14.999 17.116 14.999 16.478V15.467C15 13.382 13.609 11.574 11.617 11.071Z",
    fill: "url(#paint0_linear_1_326)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_326",
    x1: 16.4719,
    y1: -1.31633,
    x2: -2.8024,
    y2: 1.82919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0794952,
    stopColor: "#55A7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970165,
    stopColor: "#1F617D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilled);
export default __webpack_public_path__ + "static/media/user-Filled.163c3f9b98b0817f95a037eb8b755dea.svg";
export { ForwardRef as ReactComponent };